import { Text, TextType } from 'ui-components/components/text';
import { EmailAddressLink } from 'ui-components/components/email-adress-link/email-address-link';

import style from '../carriers-additional.module.less';
import messages from '../../messages';

export const OnboardingStatusPopoverContent = ({ mailTo }) => {
  return (
    <section className={style['popover-wrapper']}>
      <header className={style['popover-title']}>
        <Text textType={TextType.Label} value={messages.warningTagTooltipHeader} />
      </header>
      <Text
        className={style['popover-body']}
        formattedMessageValues={{
          supportLink: (chunks) => <EmailAddressLink emailAddress={chunks} mailTo={mailTo} />,
        }}
        textType={TextType.Paragraph}
        value={messages.warningTagTooltip}
      />
    </section>
  );
};
